export default __webpack_public_path__ + "static/interest-free-cards-old-028dea6ea40a8b0aeaa237519f8a9795.png";